import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Row, Col, Image, Button } from 'antd'
import ViewContainer from './container'

const Styled = styled.div`
  .my-sc-container {
    border-radius: 10px;
  }

  .img-absolute {
    position: absolute;
  }

  .footer-boxes {
    height: 213px;

    .fb-container {
      height: 290px;
    }
    .border {
      min-height: 190px;
      border: 1px solid #E2E2E2;
      border-radius: 10px;
    }
    .fb-left {
      padding: 25px;
    }
  }

  .sc-question {
    cursor: pointer;
  }

  @media only screen and (max-width: 768px) {
    .footer-boxes {
      margin-bottom: 120px;
    }
  }
`
export default function Index ({ redirectLink }) {
  return (
    <>
      <ViewContainer>
        {() => (
          <Styled>
            <Row className='my-7'>
              <Col
                className='footer-boxes'
                xs={{ span: 20, offset: 2 }}
                sm={{ span: 20, offset: 2 }}
                md={{ span: 11, offset: 1 }}
                lg={{ span: 11, offset: 1 }}
                xl={{ span: 11, offset: 1 }}
              >
                <Row>
                  <Col
                    className='border'
                    xs={{ span: 24, offset: 0 }}
                    sm={{ span: 24, offset: 0 }}
                    md={{ span: 23, offset: 0 }}
                    lg={{ span: 23, offset: 0 }}
                    xl={{ span: 23, offset: 0 }}
                  >
                    <Row className='fb-container'>
                      <Col
                        className='fb-left'
                        xs={{ span: 17, offset: 0 }}
                        sm={{ span: 17, offset: 0 }}
                        md={{ span: 15, offset: 0 }}
                        lg={{ span: 15, offset: 0 }}
                        xl={{ span: 15, offset: 0 }}
                      >
                        <h3 style={{ color: 'var(--cognac)', lineHeight: '40px' }}>Compare Benefits!</h3>
                        <div className='mt-2' />
                        <p style={{ lineHeight: '24px' }}>Enjoy exclusive benefits and discounts only with Supercard! Find out which one is for you.</p>
                        <div className='mt-4' />
                        <Button className='default-btn-size' type='primary' onClick={() => redirectLink('/supercard/compare')}>
                          <p style={{ fontSize: '20px' }}>Let's Go</p>
                        </Button>
                      </Col>
                      <Col
                        className='end-vh'
                        xs={{ span: 7, offset: 0 }}
                        sm={{ span: 7, offset: 0 }}
                        md={{ span: 8, offset: 1 }}
                        lg={{ span: 8, offset: 1 }}
                        xl={{ span: 8, offset: 1 }}
                      >
                        <Image draggable='false' src='/images/supercard/v2/compare-asset.svg' preview={false} alt='Compare Benefits' />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col
                className='footer-boxes'
                xs={{ span: 20, offset: 2 }}
                sm={{ span: 20, offset: 2 }}
                md={{ span: 10, offset: 0 }}
                lg={{ span: 11, offset: 0 }}
                xl={{ span: 11, offset: 0 }}
              >
                <Row>
                  <Col
                    className='border'
                    xs={{ span: 24, offset: 0 }}
                    sm={{ span: 24, offset: 0 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 23, offset: 1 }}
                    xl={{ span: 23, offset: 1 }}
                  >
                    <Row className='fb-container'>
                      <Col
                        className='fb-left'
                        xs={{ span: 17, offset: 0 }}
                        sm={{ span: 17, offset: 0 }}
                        md={{ span: 15, offset: 0 }}
                        lg={{ span: 15, offset: 0 }}
                        xl={{ span: 15, offset: 0 }}
                      >
                        <h3 style={{ color: 'var(--cognac)', lineHeight: '40px' }}>Frequently Asked Questions</h3>
                        <div className='mt-2' />
                        <p style={{ lineHeight: '24px' }}>Find out everything you need to know about Supercard here.</p>
                        <div className='mt-4' />
                        <Button className='default-btn-size' type='primary' onClick={() => redirectLink('https://www.mysupercard.ph/')}>
                          <p style={{ fontSize: '20px' }}>Learn more</p>
                        </Button>
                        {/* <Button type='primary' onClick={() => redirectLink('/supercard/faq')}>Learn more</Button> */}
                      </Col>
                      <Col
                        className='end-vh'
                        style={{ position: 'relative ' }}
                        xs={{ span: 7, offset: 0 }}
                        sm={{ span: 7, offset: 0 }}
                        md={{ span: 8, offset: 1 }}
                        lg={{ span: 8, offset: 1 }}
                        xl={{ span: 8, offset: 1 }}
                      >
                        <Image draggable='false' src='/images/supercard/sc-faq2-resized.png' preview={false} alt='FAQ' />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Styled>
        )}
      </ViewContainer>
    </>
  )
}

Index.propTypes = {
  redirectLink: PropTypes.any
}
